import Icon from '../components/Icon.vue'

Icon.register({
  'air-freshener': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M378.9 321.4L284.7 224H333.9C349.2 224 357.6 207.4 347.8 196.5L234.4 70C237.9 63.4 240 56 240 48 240 21.5 218.5 0 192 0S144 21.5 144 48C144 56 146.1 63.4 149.6 70L36.2 196.5C26.4 207.4 34.8 224 50.1 224H99.3L5.1 321.4C-6.7 333.6 3.3 352 21.7 352H160V384H48C39.2 384 32 391.2 32 400V496C32 504.8 39.2 512 48 512H336C344.8 512 352 504.8 352 496V400C352 391.2 344.8 384 336 384H224V352H362.3C380.7 352 390.7 333.6 378.9 321.4zM192 32C200.8 32 208 39.1 208 48 208 56.8 200.8 64 192 64S176 56.8 176 48C176 39.1 183.2 32 192 32zM304 432V464H80V432H304z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/air-freshener.js
// module id = 42s4
// module chunks = 144